<template>
  <div class="app-container container-xxl">
    <div class="row">
      <div class="col-xl-8 col-lg-7">
        <div class="top-page">
          <router-link class="top-page_back" :to="{ name: backList.route }">
            <inline-svg
              src="media/icons/duotune/arrows/arr022.svg"
              class="top-page_back_icon"
            />
            <span>{{ backList.label }}</span>
          </router-link>
        </div>
        <div class="deal-main">
          <div :class="`deal-main_top ${selectedDealStatus}`">
            <div class="deal-main_top_content">
              <Transition>
                <p v-if="selectedDealStatus === 'selected'">
                  This deal is in
                  <router-link to="/investment/selected"
                    >your selection</router-link
                  >. The Virtual Deal Room team will be in touch with you
                  shortly regarding your interest in this transaction.
                </p>
              </Transition>
              <span v-if="selectedDealStatus === 'archived'"
                >This deal is archived</span
              >
            </div>
            <div class="deal-main_top_button">
              <button
                @click="changeStatus.handler"
                :class="`change-status ${
                  selectedDealStatus === 'archived' ? 'special-hover' : ''
                }`"
              >
                <span clas="special-hover_first"
                  >Return to the selected deals list</span
                >
                <span class="special-hover_second">
                  {{ changeStatus.label }}</span
                >
              </button>
            </div>
          </div>
          <div class="deal-main_header">
            <div class="deal-main_header_top">
              <div class="deal-main_header_top_title">
                <h2>{{ deal.displayName }}</h2>
              </div>
            </div>
            <div class="deal-main_header_description">
              {{ deal.summary }}
            </div>
          </div>
          <div class="deal-main_content">
            <div class="deal-main_content_item">
              <h3 class="deal-main_content_item_title">FINANCE OVERVIEW</h3>
              <div class="deal-main_content_item_content">
                <div
                  class="deal-main_content_item_content_item"
                  v-if="dealSize"
                >
                  <span class="normal-text">Deal size</span>
                  <span class="bold-text">{{ dealSize }}</span>
                </div>
                <hr class="line" v-if="dealSize" />
                <div
                  class="deal-main_content_item_content_item"
                  v-if="dealType"
                >
                  <span class="normal-text">Deal type</span>
                  <span class="bold-text">{{ dealType }}</span>
                </div>
                <hr class="line" v-if="dealType" />
                <div
                  class="deal-main_content_item_content_item"
                  v-if="financingType"
                >
                  <span class="normal-text">Financing Type</span>
                  <span class="bold-text">{{ financingType }}</span>
                </div>
              </div>
            </div>
            <div class="deal-main_content_item">
              <h3 class="deal-main_content_item_title">ACTIVITY</h3>
              <div class="deal-main_content_item_content">
                <div
                  class="deal-main_content_item_content_item"
                  v-if="activity.sector"
                >
                  <span class="normal-text">Sector</span>
                  <span class="bold-text">{{ activity.sector }}</span>
                </div>
                <hr class="line" v-if="activity.sector" />
                <div
                  class="deal-main_content_item_content_item"
                  v-if="activity.country"
                >
                  <span class="normal-text">Country</span>
                  <span class="bold-text">{{ activity.country }}</span>
                </div>
              </div>
            </div>
            <div class="deal-main_content_item" v-if="materials.length !== 0">
              <h3 class="deal-main_content_item_title">AVAILABLE MATERIALS</h3>
              <div class="deal-main_content_item_content">
                <div
                  v-for="(material, index) in materials"
                  :key="material.value"
                  class="w-100"
                >
                  <div class="deal-main_content_item_content_item">
                    <span class="bold-text">{{ material.label }}</span>
                    <inline-svg src="media/icons/duotune/arrows/arr085.svg" />
                  </div>
                  <hr class="line" v-if="index !== materials?.length - 1" />
                </div>
              </div>
            </div>
          </div>
          <!-- <footer class="deal-main_als-footer" v-if="isAlsDeal">
        <div class="deal-main_als-footer_left">
          <span
            >Attendees at ALS can speak to the team of investment experts.</span
          >
          <span
            >This opportunity is being presented at the "US Africa Business
            Forum" room</span
          >
        </div>
        <div class="deal-main_als-footer_right">
          <img src="media/logos/prosper-logo-2.png" />
        </div>
      </footer> -->
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import options from "@/core/data/options";
import { getMaterialLabel } from "@/core/helpers/format";

export default {
  name: "deal-page",
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    interest() {
      return this.$store.getters["account/interest"];
    },
    deal() {
      return this.$store.getters["deals/selectedDeal"];
    },
    selectedDealStatus() {
      return this.$store.getters["deals/selectedDealStatus"];
    },
    dealSize() {
      return (
        (options.dealRanges.find((d) => d.value === this.deal.dealRanges) || {})
          .name || this.deal.dealRanges
      );
    },
    dealType() {
      if (this.deal.isLpEquity) {
        return "LP Equity";
      }
      if (this.deal.isEquityInvestment && this.deal.isTradeDeal) return "Both";
      if (this.deal.isEquityInvestment) return "Investment";
      if (this.deal.isTradeDeal) return "Trade";
      return "Flexible";
    },
    financingType() {
      return (
        [
          this.deal.isDebtInvestment && "Debt",
          this.deal.isEquityInvestment && "Equity",
        ]
          .filter((t) => !!t)
          .join(" & ") || this.deal.purpose
      );
    },
    activity() {
      return {
        sector: this.deal.sector,
        country: this.deal.baseCountry,
      };
    },
    materials() {
      const materialList = _.get(this, "deal.materials", []).map((material) =>
        getMaterialLabel(material)
      );
      return materialList || [];
    },
    backList() {
      const backLitsMap = {
        available: { route: "deals", label: "Back to available deals" },
        selected: { route: "selected-deals", label: "Back to selected deals" },
        archived: { route: "archived-deals", label: "Back to archived deals" },
      };
      return backLitsMap[this.selectedDealStatus];
    },
    changeStatus() {
      const buttonMap = {
        available: { label: "Select", handler: this.handleSelect },
        selected: { label: "Archive", handler: this.handleArchive },
        archived: { label: "Unarchived", handler: this.handleUnarchive },
      };
      return buttonMap[this.selectedDealStatus];
    },
  },
  watch: {
    id: {
      handler(newId) {
        if (newId) {
          this.$store.dispatch("deals/selectDeal", newId);
        }
      },
      immediate: true,
    },
    deal: {
      handler(newDeal) {
        if (newDeal?._id) {
          this.isLoading = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleSelect() {
      const payload = { ...this.interest };
      payload.deals = _.uniqBy((payload.deals || []).concat(this.deal), "_id");
      return this.$store.dispatch("account/update", payload);
    },
    handleUnarchive() {
      const payload = { ...this.interest };
      const deal = payload.deals.find((d) => d._id === this.deal._id);
      deal.archivedAt = null;
      deal.addedAt = Date.now();
      return this.$store.dispatch("account/update", payload);
    },
    handleArchive() {
      const payload = { ...this.interest };
      const deal = payload.deals.find((d) => d._id === this.deal._id);
      deal.archivedAt = Date.now();
      return this.$store.dispatch("account/update", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
$title-font-color: #0e3167;
$content-font-color: #7e8299;

.top-page {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 30px;
  padding: 35px 30px 0px 0px;

  &_back {
    display: flex;
    justify-content: start;
    align-items: center;

    padding: 0px;

    background-color: inherit;
    border: none;
    color: $title-font-color;
    font-weight: 700;
    cursor: pointer;

    &_icon {
      height: 14px;
      width: 15px;
    }
  }
}

.deal-main {
  width: 100%;
  max-width: 840px;

  background: #ffffff;
  border: 1px solid #eff2f5;
  border-radius: 12px;
  box-shadow: 0px 0px 6px rgba(76, 87, 125, 0.09);

  &_top {
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 18px 28px;

    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    &_content {
      flex: 5;
      width: 100%;

      font-weight: 400;
      font-size: 12px;
      color: #7e8299;
    }

    &_button {
      flex: 3;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

  &_header {
    width: 100%;
    margin-bottom: 30px;

    padding: 30px 30px 0px 30px;

    &_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      margin-bottom: 18px;

      &_title {
        display: flex;
        justify-content: start;
        align-items: center;

        h2 {
          font-weight: 600;
          font-size: 20px;
          color: $title-font-color;
        }

        &_icon {
          width: 33px;
          height: 33px;
          margin-left: 10px;
        }
      }
    }

    &_description {
      color: $content-font-color;
      text-align: start;
      font-size: 16px;
    }
  }

  &_content {
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: start;
    flex-wrap: wrap;

    padding: 0px 30px 50px 30px;

    &_item {
      width: 100%;
      max-width: 290px;

      margin-bottom: 50px;

      &_title {
        font-weight: 700;
        font-size: 13px;
        color: $title-font-color;

        margin-bottom: 15px;
      }

      &_content {
        width: 100%;

        display: flex;
        flex-direction: column;
        align-items: start;

        column-gap: 40px;

        &_item {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }

  &_als-footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 30px 30px 35px 30px;
    background-color: #dca93d1c;

    &_left {
      display: flex;
      flex-direction: column;
      row-gap: 10px;

      font-weight: 400;
      font-size: 14px;
      color: #7e8299;
    }
  }
}

.available {
  background: rgba(255, 255, 255, 0.07);
  border-bottom: 1px solid #e7edf7;

  transition: background-color 1s;
}

.archived {
  background: #fbfbfb;
  transition: background-color 1s;
}

.selected {
  background: rgba(220, 169, 61, 0.07);
  transition: background-color 1s;
}

.change-status {
  width: 150px;
  height: 34px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 8px 23px;

  background: #ffffff;
  border: 1.2px solid #0e3167;
  border-radius: 6px;

  font-weight: 500;
  font-size: 15px;
  color: #0e3167;

  span:first-child {
    display: none;
  }
}

.special-hover {
  display: flex;
  justify-content: center;
  align-items: center;

  overflow-y: hidden;

  transition: width 1s;

  span:first-child {
    display: block;
    width: 0px;
    opacity: 0;
    transition: opacity 0.1s;
  }

  &:hover {
    width: 260px;
    background-color: #e6eff6;
    transition: all 0.2s;
    overflow-x: hidden;

    span:first-child {
      width: auto;
      opacity: 1;
      transition-delay: 0.3s;
      transition: all 2s;
      // background-color: red;
    }

    span:last-child {
      opacity: 0;
      width: 0px;
      transition: all 0.1s;
      overflow-x: hidden;
    }
  }

  // &_normal {
  //   transition: 0.6s;
  //   transition-delay: 0.2s;
  // }
  // &_hover {
  //   display: none;
  //   flex: 0;
  //   text-align: center;
  //   opacity: 0;
  //   transition: 0.4s, opacity 0.6s;
  // }

  // &_normal:hover {
  //   display: none;
  //   width: 0px;
  //   flex: 0;
  //   opacity: 0;
  //   transform: all 0.6s;
  // }

  // &_hover:hover {
  //   display: flex;
  //   width: 100%;
  //   flex: 1;
  //   opacity: 1;
  //   transform: opacity 0.6s;
  //   transition-delay: 0.4s;
  // }
}

.normal-text {
  font-weight: 500;
  font-size: 14px;
  color: $content-font-color;
}

.bold-text {
  font-weight: 700;
  font-size: 14px;
  color: $title-font-color;
}

.line {
  width: 100%;
  margin-top: 14px;
  border-top: 1px dashed $content-font-color;
}

.download-button {
  background-color: inherit;
  border: none;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
